import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          {/* Left: Text */}
          <div className="lg:w-[42%]">
            <span className="inline-block px-3 py-1 rounded-full border border-foreground-300/40 text-xs font-medium text-foreground-600 mb-6">
              Chi Siamo
            </span>

            <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
              Il Database Italiano
            </h2>
            <p className="font-heading text-4xl md:text-5xl text-accent-600 font-light italic mt-1">
              Per Lo Shopping
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-10 max-w-md">
              Itaobuy Spreadsheet &egrave; nato dalla passione per lo shopping intelligente. Offriamo una piattaforma organizzata dove trovare le migliori categorie di prodotti, confrontare opzioni e accedere direttamente agli articoli pi&ugrave; ricercati del momento. La nostra missione &egrave; rendere l&apos;esperienza di acquisto pi&ugrave; semplice, veloce e consapevole per tutti gli utenti italiani.
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-4 max-w-md">
              Con oltre <strong className="text-foreground-900">14 categorie</strong> e migliaia di prodotti indicizzati, itaobuy spreadsheet si aggiorna costantemente per offrirti sempre il meglio dello shopping online.
            </p>

            <Link
              to="/guida-completa"
              className="inline-flex items-center gap-2 mt-8 text-sm font-medium text-foreground-800 hover:text-foreground-950 border-b border-foreground-300 hover:border-foreground-700 transition-colors duration-200 pb-1 whitespace-nowrap cursor-pointer"
            >
              Scopri tutte le guide <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>

          {/* Right: Stats + Images */}
          <div className="lg:w-[58%] relative">
            {/* Stats */}
            <div className="flex gap-12 md:gap-20 justify-end mb-10">
              <div className="text-right">
                <p className="font-heading text-5xl md:text-6xl font-bold text-foreground-950">14+</p>
                <p className="text-xs text-foreground-500 mt-1">Categorie</p>
              </div>
              <div className="text-right">
                <p className="font-heading text-5xl md:text-6xl font-bold text-foreground-950">20K+</p>
                <p className="text-xs text-foreground-500 mt-1">Prodotti</p>
              </div>
            </div>

            {/* Images - diagonal stack */}
            <div className="relative h-[350px] md:h-[420px]">
              <div className="absolute top-0 left-0 w-44 md:w-56 aspect-square rounded-2xl overflow-hidden border-4 border-background-50">
                <img
                  src="https://readdy.ai/api/search-image?query=Curated%20fashion%20inspiration%20board%20with%20fabric%20swatches%20style%20sketches%20and%20elegant%20accessories%20on%20warm%20cream%20cork%20board%2C%20soft%20Mediterranean%20daylight%2C%20editorial%20mood%20board%20aesthetic%2C%20terracotta%20sage%20green%20and%20sand%20palette%2C%20creative%20designer%20workspace&width=560&height=560&seq=itaobuy-about-v2-sq&orientation=squarish"
                  alt="Itaobuy Spreadsheet shopping di qualit\u00e0"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="absolute top-20 md:top-28 right-0 md:right-8 w-40 md:w-52 aspect-[3/4] rounded-2xl overflow-hidden border-4 border-background-50">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegantly%20draped%20cashmere%20scarf%20with%20delicate%20gold%20jewelry%20pieces%20on%20warm%20cream%20linen%20background%2C%20soft%20golden%20Mediterranean%20hour%20lighting%2C%20luxury%20editorial%20product%20photography%2C%20minimal%20sophisticated%20composition%2C%20rich%20textural%20details&width=520&height=694&seq=itaobuy-about-v2-portrait&orientation=portrait"
                  alt="Itaobuy Spreadsheet accessori moda"
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}